<template>
	<div id="fUser" v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 阳光配餐报表</el-breadcrumb-item>
				<el-breadcrumb-item>消费结算设置</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container" v-if="power.search">
			<div class="handle-box left">
				<el-button type="primary" icon="el-icon-search" @click="search" v-if="power.search">刷新</el-button>
				<el-button type="primary" icon="el-icon-circle-check" @click="save" v-if="power.save">保存</el-button>
			</div>
			<el-table id="balanceBooksRecordTable" ref="table" :data="data.rows" border class="table">
				<el-table-column align="left" prop="empTypeName" label="人员类别\餐别" width="220">
				</el-table-column>
				<el-table-column align="center" prop="balance1" label="早餐" width="160">
					<template slot-scope="scope">
						<el-input-number size="mini" v-model="scope.row.balance1" :precision="2"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="balance2" label="中餐" width="160">
					<template slot-scope="scope">
						<el-input-number size="mini" v-model="scope.row.balance2" :precision="2"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="balance3" label="晚餐" width="160">
					<template slot-scope="scope">
						<el-input-number size="mini" v-model="scope.row.balance3" :precision="2"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="balance4" label="前夜" width="160">
					<template slot-scope="scope">
						<el-input-number size="mini" v-model="scope.row.balance4" :precision="2"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="balance5" label="后夜" width="160">
					<template slot-scope="scope">
						<el-input-number size="mini" v-model="scope.row.balance5" :precision="2"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="holiday" label="节假日" width="120">
					<template slot-scope="scope">
						<el-tag type="success" v-if="scope.row.holiday == 1">节假日</el-tag>
						<el-tag type="info" v-else-if="scope.row.holiday == 0">平日</el-tag>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="online" label="扣款类别" width="120">
					<template slot-scope="scope">
						<el-tag type="success" v-if="scope.row.online == 1">线上</el-tag>
						<el-tag type="info" v-else-if="scope.row.online == 2">线下</el-tag>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="first" label="首笔" width="120">
					<template slot-scope="scope">
						<el-tag type="success" v-if="scope.row.first == 1">是</el-tag>
						<el-tag type="info" v-else-if="scope.row.first == 0">否</el-tag>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'yhbalancesetting',
		data() {
			return {
				data: {
					rows: [],
				},
				visible: {
					loading: false
				},
				power: {
					pageId: 96,
					search: false,
					save: false
				}
			}
		},
		methods: {
			search(change) {
				let ths = this;
				ths.visible.loading = true;
				window.ax.get('api/report/yhpos/getbalancesetting?sign=' + window.$gloable.userinfo.sign, {}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.data.rows = data.data;
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					console.log(err);
					ths.visible.loading = false;
				});
			},
			save() {
				let ths = this;
				ths.visible.loading = true;
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					Items: []
				};
				for (let i = 0;i < ths.data.rows.length; i++) {
					let r = ths.data.rows[i];
					let type = r.empType;
					let holiday = r.holiday;
					let online = r.online;
					let first = r.first;
					for (let j = 1; j < 6; j++) {
						let balance = r['balance' + j];
						opt.Items.push({ Meal: j, EmpType: type, Balance: balance, Holiday: holiday, Online: online, First: first });
					}
				}
				window.ax.post('api/report/yhpos/savebalancesetting', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.search();
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					console.log(err);
					ths.visible.loading = false;
				});
			}
		},
		created() {
			let ths = this;
			var d = new Date();
			d.setMonth(d.getMonth() - 1);
			d.setDate(1);
			var d1 = new Date(d);
			d1.setMonth(d1.getMonth() + 1);
			d1.setDate(0);
			ths.data.date = [d.toDateFormatString('yyyy-MM-dd'), d1.toDateFormatString('yyyy-MM-dd')];
			ths.baseJS.initPower(ths.power);
			ths.search();
		},
		mounted() {}
	}
</script>

<style scoped>
	.is-current {
		background: #cccccc;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.left {
		float: left;
	}

	.right {
		float: right;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.del-dialog-cnt {
		font-size: 16px;
		text-align: center
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.mr10 {
		margin-right: 10px;
	}

	.m10 {
		margin: 10px;
	}

	.mt1 {
		margin-top: 1px;
	}

	.fr {
		float: right;
	}

	.form-warp {
		position: relative;
		width: 560px;
		height: 520px;
		padding-left: 200px;
		border: 1px solid #ccc;
	}

	.form-warp-left {
		position: absolute;
		left: 0;
		top: 0;
		width: 200px;
		height: 492px;
		padding-top: 28px
	}

	.department-search {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd;
		border-right: 1px solid #ddd;
	}

	.department-tree {
		position: relative;
		height: 490px;
		width: 100%;
		border-right: 1px solid #ddd
	}

	.form-warp-main {
		position: relative;
		height: 492px;
		width: 100%;
		padding-top: 28px
	}

	.employee-search {
		position: absolute;
		top: 0;
		left: 1px;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd
	}

	.list {
		position: relative;
		height: 492px;
		width: 560px
	}

	.card-box {
		position: relative;
		float: left;
		width: 100px;
		height: 60px;
		border: 1px solid #ccc;
		background-color: #fff;
		border-radius: 3px;
		margin: 10px 0 0 10px;
		padding-left: 69px;
		overflow: hidden;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		-khtml-user-select: none;
		user-select: none;
		cursor: pointer
	}

	.card-box.active {
		border: 1px solid #ff5d5b;
		background: url(../../assets/img/selected_red.png) right top no-repeat
	}

	.card-box-img {
		position: absolute;
		left: 0;
		top: 0;
		width: 56px;
		height: 60px;
		line-height: 60px;
		padding-left: 5px;
		background-color: #ebebeb;
		border-right: 1px solid #ccc
	}

	.card-box-img img {
		border-radius: 45px;
		width: 50px;
		height: 50px;
		margin-top: 5px;
	}

	.card-box-content {
		padding: 6px 0
	}

	.card-box-content p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0;
		font-size: 10px
	}

	.form-warp-right {
		position: absolute;
		top: 0;
		right: 0;
		height: 492px;
		width: 180px;
		border-left: 1px solid #ddd;
		padding-top: 28px;
		background-color: #fff;
		z-index: 10;
		transition: all 300ms;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.form-warp-right.hide {
		width: 0px;
	}

	.form-warp-right-close {
		position: absolute;
		top: 7px;
		right: 4px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer
	}

	.form-warp-right-close:hover {
		background-position: 0 -12px
	}

	.form-warp-right-title {
		position: absolute;
		top: 0;
		right: 0;
		height: 28px;
		line-height: 27px;
		padding-left: 10px;
		width: 170px;
		border-bottom: 1px solid #ddd;
		cursor: pointer
	}

	.selected-list-warp {
		position: relative;
		height: 492px;
		width: 180px;
	}

	.selected-box {
		position: relative;
		width: 150px;
		height: 55px;
		border: 1px solid #ccc;
		border-radius: 4px;
		margin: auto;
		margin-top: 10px;
		padding: 5px 0 0 10px
	}

	.selected-box p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0
	}

	.remove {
		position: absolute;
		top: 2px;
		right: 2px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer;
		opacity: 0.5
	}

	.remove:hover {
		opacity: 1
	}

	.selected-btn {
		position: absolute;
		top: 0;
		right: 1px;
		height: 100%;
		width: 80px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.selected-btn:hover {
		color: #333
	}

	.form-control {
		border: 0;
		height: 100%;
	}

	.input-query {
		position: absolute;
		right: 146px;
		top: 5px;
		color: #ccc;
		font-size: 16px;
		cursor: pointer
	}

	.select-all {
		position: absolute;
		top: 0;
		right: 80px;
		height: 100%;
		width: 60px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.span-ellipsis {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		display: block;
	}
</style>
